// extracted by mini-css-extract-plugin
export default {"root":"BundleQuote-root","image":"BundleQuote-image","text":"BundleQuote-text","name":"BundleQuote-name"};